import React, { Component } from 'react'
import LoginTemplate from 'templates/LoginPage'
import LoginCover from 'organisms/LoginCover'
import PassResetFormTitled from 'organisms/PassResetFormTitled'
import { sendResetPassword } from 'services/authService'
import { withRouter } from 'react-router-dom'
import qs from 'qs'

const srcCover = require('App/assets/images/ic_cover_forgot_pass.png')

class PasswordReset extends Component {
  constructor(props) {
    super(props)
    this.state = {
      newPasswordData: {
        password: '',
        passwordConfirm: ''
      },
      isBtnDisabled: false,
      isShowForm: true,
      isWarning: false,
      btnLabel: 'Done',
      formTitle: 'Reset Password',
      msg: ''
    }

    this.handleUserInput = this.handleUserInput.bind(this)
    this.doSendCall = this.doSendCall.bind(this)
  }

  handleUserInput(value, itemName) {
    let obj = Object.assign(this.state.newPasswordData)
    obj[itemName] = value;
    this.setState({ newPasswordData: obj });
  }

  // method for sending password reset
  doSendCall(e) {
    e.preventDefault()
    const { newPasswordData } = this.state
    const { password, passwordConfirm } = newPasswordData
    const { location: { search } } = this.props
    const token = qs.parse(search)['?token']

    if (password.length && passwordConfirm.length && (password === passwordConfirm)) {
      this.setState({
        isWarning: false,
        msg: '',
        isBtnDisabled: true,
        btnLabel: 'Sending...'
      }, async () => {
        const res = await sendResetPassword(newPasswordData, token)
        if ( res.status === 201) {
          const msg = `Your password has been sucsessfully changed.`
          this.setState({
            msg: msg,
            isShowForm: false,
            formTitle: 'Congratulations'
          })
        }
      })
    } else if (password !== passwordConfirm) {
      this.setState({
        isWarning: true,
        msg: 'Password mismatches. Please recheck.'
      })
    } else {
      this.setState({
        isWarning: true,
        msg: 'One or more field are empty. Please fill out'
      })
    }
  }

  render() {
    return (
      <LoginTemplate
        leftForm={
          <PassResetFormTitled
            title={this.state.formTitle}
            fnOnChange={this.handleUserInput}
            fnOnSubmit={this.doSendCall}
            {...this.state}
          />
        }
        cover={<LoginCover coverSrc={srcCover} />}
      />
    );
  }
}

export default withRouter(PasswordReset);
